import {
  ActionCableData,
  ActionCableSubscription,
  ActionCableChannelPayload,
} from "@/types";
import { buildActionCableUrl } from "@/utils/meta";
import * as ActionCable from "@rails/actioncable";

export function useActionCableChannel(
  channel: string,
  payload: ActionCableChannelPayload,
  {
    onUpdate,
    onConnected,
    retrieveHistory,
  }: {
    onUpdate: (data: ActionCableData) => void;
    onConnected?: () => void;
    retrieveHistory?: () => void;
  }
): ActionCableSubscription {
  const consumer = ActionCable.createConsumer(buildActionCableUrl());
  let isDisconnected = false;
  const subscription = consumer.subscriptions.create(
    { channel, ...payload },
    {
      // Called when the subscription is ready for use on the server
      connected() {
        if (onConnected) onConnected();

        // eslint-disable-next-line no-console
        console.log("connected");

        if (isDisconnected) {
          if (retrieveHistory) retrieveHistory();
          isDisconnected = false;
          // eslint-disable-next-line no-console
          console.log("reconnected");
        }
      },

      // Called when the subscription has been terminated by the server
      disconnected() {
        isDisconnected = true;
        // eslint-disable-next-line no-console
        console.log("disconnected - connection to server lost");
      },

      // Called when the subscription is rejected by the server.
      rejected() {
        // openErrorDialog(t("errors.connectionRejected"));
        alert("Connection was rejected by the server");
      },

      received(data: ActionCableData) {
        onUpdate(data);
      },

      unsubscribe() {
        consumer.subscriptions.remove(this);
        this.perform("unsubscribed");
      },
    }
  );

  return {
    unsubscribe: () => subscription.unsubscribe(),
  };
}
